var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$route.path === '/sign_in' || _vm.$route.path === '/password' || _vm.$route.path === '/password/edit'
      ? 'sign-in'
      : 'others',attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.path})],1)}
var staticRenderFns = []

export { render, staticRenderFns }